import {
    AfterContentInit,
    AfterViewInit,
    ChangeDetectionStrategy,
    Component,
    ContentChild,
    Input,
    OnDestroy,
    OnInit,
    TemplateRef,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AuthService, CanComponentDeactivate } from '@klickdata/core/auth';
import { MobileService } from '@klickdata/core/mobile';
import { Post } from '@klickdata/core/post';
import { AppScope } from '@klickdata/core/resource';
import { GlobalFilterProperty, SelectFilterOption } from '@klickdata/core/table';
import { Utils } from '@klickdata/core/util';
import { Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { SelectModelBaseDirective } from '../../selection-handler/select-model-base/select-model-base.component';
import { PostsSelectDatatableService } from './posts-select-datatable.service';

@Component({
    selector: 'app-posts-selection-listing',
    templateUrl: './posts-selection-listing.component.html',
    styleUrls: ['./posts-selection-listing.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [PostsSelectDatatableService],
})
export class PostsSelectionListingComponent
    extends SelectModelBaseDirective<Post>
    implements OnInit, AfterViewInit, CanComponentDeactivate, OnDestroy, AfterContentInit
{
    @Input() accessForm: FormGroup;
    @Input() referenceFilter: string;
    @Input() customer_id: number;
    @Input() prefLangIds: number[];
    @Input() sync_all_key = 'sync_all';
    @Input() attachKey = 'attach_ids';
    @Input() detachKey = 'detach_ids';
    @Input() extraFilters: { property: string; items: any }[];
    @ContentChild('tools') tools: TemplateRef<any>;
    @Input() columns = ['select', 'title', 'created_by', 'created_at'];
    @Input() eager: string[] = [];
    @Input() referencePropertyValue: any;
    GlobalFilterProperty = GlobalFilterProperty;
    AppScope = AppScope;
    public itemSelectedOptions: SelectFilterOption[];
    public isMasterAdmin$: Observable<boolean>;

    constructor(
        public datatableService: PostsSelectDatatableService,
        protected mobileService: MobileService,
        protected auth: AuthService
    ) {
        super(datatableService, mobileService);
        this.itemSelectedOptions = Utils.getItemSelectedOptions();
        this.isMasterAdmin$ = this.auth.getUser().pipe(
            first(),
            map((user) => user.isMasterAdmin())
        );
    }

    public refresh(id?: any): void {
        const filters: Array<{ property: string; items: (string | number)[] }> = [];
        if (!!this.eager?.length) {
            filters.push({ property: 'eager', items: this.eager });
        }
        if (this.referenceFilter) {
            filters.push({ property: this.referenceFilter, items: [this.referencePropertyValue ?? id] });
        }
        if (this.customer_id) {
            filters.push({ property: 'assignedOrCustomer', items: [this.customer_id] });
        }
        if (!!this.extraFilters?.length) {
            this.extraFilters.forEach((fltr) => filters.push(fltr));
        }
        this.filter?.createOrUpdateWithoutEmitFilter(filters);
    }
    detectIdKeyValueChange() {
        if (this.referenceFilter) {
            super.detectIdKeyValueChange();
        } else {
            this.refresh();
        }
    }
    ngAfterContentInit(): void {
        if (this.tools) {
            this.columns.push('tools');
        }
    }
}
